export function incrementClickSequence() {
    return { type: "INCREMENT_CLICK_SEQUENCE" };
}

export function resetClickSequence() {
    return { type: "RESET_CLICK_SEQUENCE" };
}


// WEBPACK FOOTER //
// ./src/actions/clickSequence.js